@use 'variables' as *;
@use 'mixins' as *;
@use '_snippets/form-label';

:host {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

:host([hidden]) {
  display: none;
}

.label-hidden,
.label-container:empty {
  display: none;
}

.picker {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.picker-head {
  display: flex;
  align-items: center;
  container-type: inline-size;

  > :not(:last-child) {
    // we use margin here instead of gap to be able to properly adjust by container query
    margin-right: 0.25rem;
  }

  h3 {
    @include cat-head(5);
    flex: 1;
    text-align: center;
    margin-block: 0;
  }

  @container (min-width: 20rem) {
    h3 {
      @include cat-head(4);
    }

    > :not(:last-child) {
      margin-right: 0.5rem;
    }
  }
}

.picker-grid {
  display: grid;
  /* stylelint-disable declaration-block-no-redundant-longhand-properties */
  grid-template-rows: 2rem repeat(6, 1fr);
  grid-template-columns: repeat(7, 1fr);
  grid-template-areas:
    'h h h h h h h'
    'd d d d d d d'
    'd d d d d d d'
    'd d d d d d d'
    'd d d d d d d'
    'd d d d d d d'
    'd d d d d d d';
  /* stylelint-enable declaration-block-no-redundant-longhand-properties */

  .picker-weeks & {
    /* stylelint-disable declaration-block-no-redundant-longhand-properties */
    grid-template-columns: 2rem repeat(7, 1fr);
    grid-template-areas:
      '. h h h h h h h'
      'w d d d d d d d'
      'w d d d d d d d'
      'w d d d d d d d'
      'w d d d d d d d'
      'w d d d d d d d'
      'w d d d d d d d';
    /* stylelint-enable declaration-block-no-redundant-longhand-properties */
  }
}

.picker-grid-head {
  grid-area: h;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  place-items: end center;
  padding-bottom: 0.5rem;
}

.picker-grid-weeks {
  grid-area: w;
  display: grid;
  grid-template-rows: repeat(6, 1fr);
  place-items: center right;
  padding-right: 0.5rem;
}

.picker-grid-days {
  grid-area: d;
  display: grid;
  grid-template-rows: repeat(6, 1fr);
  grid-template-columns: repeat(7, 1fr);
}

.picker-grid-head > *,
.picker-grid-weeks > * {
  @include cat-body('xs', 600);
  color: cat-token('color.ui.font.muted') !important;
  text-decoration: none;
}

.date-other {
  opacity: 0.5;
}

.date-disabled {
  opacity: 0.25;
}

.picker-foot {
  display: flex;
  align-items: center;
  width: min-content;
  min-width: 100%;
  justify-content: space-between;
  container-type: inline-size;

  > :not(:last-child) {
    // we use margin here instead of gap to be able to properly adjust by container query
    margin-right: 0.25rem;
  }

  @container (min-width: 20rem) {
    > :not(:last-child) {
      margin-right: 0.5rem;
    }

    .cursor-help {
      @include cat-body('s');
    }
  }
}

.cursor-help {
  margin-block: 0;
  @include cat-body('xs');
  color: cat-token('color.ui.font.muted') !important;
  text-align: center;
  flex: 1;

  &:first-child {
    text-align: left;
  }

  &:last-child {
    text-align: right;
  }

  &:only-child {
    text-align: center;
  }
}

.cursor-aria {
  @include cat-visually-hidden;
}

.date-range {
  --cat-border-radius-m: 0;
}
